export default "__VITE_PUBLIC_ASSET__58545b38__"